import { memo } from "react";
import { Table } from "antd";

const LeaveRequestTable = memo((props) => {
  return <Table {...props} />;
});

export default LeaveRequestTable;
